import React from "react";
import DoctorHeader from "./DoctorHeader";
import DoctorSideBar from "./DoctorSideBar";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Button } from "react-bootstrap";
const DoctorProfile = () => {
  return (
    <>
      <DoctorHeader />
      <DoctorSideBar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">My Profile</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="card-title col">
                    <h4>Personal Info</h4>
                  </div>
                  <hr />
                  <div className="profile-basic">
                    <div className="row">
                      <div className="col-md-5">
                        <div>
                          <p>Cristina Groves</p>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div>
                          <p>Cristina Groves</p>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div>
                          <p>Cristina Groves</p>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div>
                          <p>Cristina Groves</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="card-title col">
                    <h4>
                    Clinic Info
                    </h4>
                  </div>
                  <hr/>
                  <div className="row">
                      <div className="col-md-12">
                        <div>
                          <p><b>Sunflower Wellness Center</b></p>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div>
                          <p>1988 (Estb. Since)</p>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div>
                          <p> 547895 (Reg. No.)</p>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div>
                          <p> location doctor is good (About Organization)</p>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="card-title col">
                    <h4>Contact Details</h4>
                  </div>
                  <hr/>
                  <div className="row">
                    <div className="col-md-12">
                      <p>98xxxxxxxx</p>
                    </div>
                    <div className="col-md-12">
                      <p>email.com</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="card-title">
                    <h4>Certifications Docs</h4>
                  </div>
                  <hr/>
                  <div className="profile-basic-doctor">
                    <div className="row"> 
                      <div className="col-md-3">
                        <Button>Speciality</Button>
                      </div>
                      <div className="col-md-6">
                        <Button>Upload Document</Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorProfile;
